import { ifDefined } from "@faedev/editor-utils";
import constants from "src/constants";

function getLink(
  lang: string,
  page?: string | null | undefined,
  slug?: string | null | undefined,
  id?: string | null | undefined
): string {
  return (
    constants.Paths.appUrl +
    `/` +
    lang +
    `/` +
    ifDefined(
      page,
      (value) => (value === "classes?paid=true" ? value : value + `/`),
      () => ``
    ) +
    ifDefined(
      slug,
      (value) => value + `/`,
      () => ``
    ) +
    ifDefined(
      id,
      (value) => value + `/`,
      () => ``
    )
  );
}

export default getLink;
